// assets/floating-product.js
// <floating-product>: imagen con reveal dramático cada vez que la sección entra en viewport,
// y que vuelve a su estado oculto cuando sale, para repetirse si el usuario hace scroll de ida y vuelta.
// CSS controla toda la animación vía data-fp-state; este JS solo orquesta la secuencia.

(function () {
  'use strict';

  if (customElements.get('floating-product')) return;

  class FloatingProduct extends HTMLElement {
    connectedCallback() {
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.img = this.querySelector('.floating-product__img');
      if (this.img) {
        const direction = this.dataset.fpDirection || 'up';
        this.img.dataset.fpDirection = direction;
        this.img.dataset.fpState = 'hidden';
      }

      this.loopEnabled = this.dataset.fpLoop !== 'false';
      this._revealTimer = null;

      this._io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            this.reveal();
          } else {
            this.hide();
          }
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.2 }
      );
      this._io.observe(this);
    }

    reveal() {
      if (!this.img) return;
      clearTimeout(this._revealTimer);

      if (this.prefersReducedMotion) {
        // Sin animación: la imagen aparece directamente en su estado final.
        this.img.dataset.fpState = this.loopEnabled ? 'floating' : 'revealing';
        return;
      }

      // Si ya estaba revelada/flotando (reentrada rápida), no reinicia desde cero.
      if (this.img.dataset.fpState !== 'hidden') return;

      // Paso 1: dispara la transición de entrada (hidden -> revealing)
      requestAnimationFrame(() => {
        this.img.dataset.fpState = 'revealing';
      });

      // Paso 2: al terminar la transición de entrada, pasa al loop continuo (si está habilitado)
      const onTransitionEnd = (e) => {
        if (e.target !== this.img) return;
        this.img.removeEventListener('transitionend', onTransitionEnd);
        if (this.loopEnabled) {
          this.img.dataset.fpState = 'floating';
        }
      };
      this.img.addEventListener('transitionend', onTransitionEnd);

      // Respaldo: si transitionend no dispara, fuerza el cambio de estado.
      this._revealTimer = setTimeout(() => {
        if (this.img.dataset.fpState === 'revealing' && this.loopEnabled) {
          this.img.dataset.fpState = 'floating';
        }
      }, 1300);
    }

    hide() {
      if (!this.img || this.prefersReducedMotion) return;
      clearTimeout(this._revealTimer);
      this.img.dataset.fpState = 'hidden';
    }

    disconnectedCallback() {
      this._io?.disconnect();
      clearTimeout(this._revealTimer);
    }
  }

  customElements.define('floating-product', FloatingProduct);
})();